module.exports = __webpack_public_path__ + "static/media/ru.51199889.svg";